import { Component, Input, OnInit } from '@angular/core';
import { CameraHandlerService } from 'src/app/services/camera-handler.service';
import { AssessmentScreenPartUploadImage } from '@bluecrew/crew-member-backend-angular-client';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-screen-part-upload-image',
  templateUrl: './screen-part-upload-image.component.html',
  styleUrls: ['./screen-part-upload-image.component.scss'],
})
export class ScreenPartUploadImageComponent implements OnInit {

  @Input() screenPart: AssessmentScreenPartUploadImage;
  @Input() controlName: string;
  @Input() nextClicked$: Observable<boolean>;

  parentFormGroup: UntypedFormGroup;
  uploadedImageSrc: string;
  hasPreviousUpload: boolean = false;
  nextClicked: boolean;
  ngUnsubscribe = new Subject();

  constructor(
    private controlContainer: ControlContainer,
    private cameraHandlerService: CameraHandlerService) { }

  ngOnInit() {
    // Set our form property to the parent control
    // (i.e. FormGroup) that was passed to us, so that our
    // view can data bind to it
    this.parentFormGroup = <UntypedFormGroup>this.controlContainer.control;

    this.hasPreviousUpload = this.parentFormGroup.get(this.controlName)?.value?.startsWith('_')

    this.nextClicked$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (nextClicked) => {
      this.nextClicked = nextClicked;
      if (nextClicked && this.screenPart.shouldNextButtonOpenCamera && !this.hasPreviousUpload && !this.uploadedImageSrc) {
        await this.uploadImage();
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  async uploadImage() {
    await this.cameraHandlerService.getReducedSizeBase64JPEGImage().then(response => {
      this.uploadedImageSrc = 'data:image/jpeg;base64, ' + response;
      this.parentFormGroup.get(this.controlName).setValue(response);
    }).catch(error => {
      console.error(error);
    });
  }

}
